<nb-card>
  <nb-card-header>Select the main house for this Granny Flat</nb-card-header>
  <nb-card-body>
    <p>GF: {{ sourceLabel }}</p>
    <p>Find the main house on the same street. Number ranges are preserved.</p>
    <div class="search-fields">
      <input nbInput placeholder="Main house number" aria-label="Main house number" [(ngModel)]="fromNumber" (ngModelChange)="invalidate()" [disabled]="busy">
      <input nbInput placeholder="Number To (optional)" aria-label="Number To" [(ngModel)]="toNumber" (ngModelChange)="invalidate()" [disabled]="busy">
      <button nbButton type="button" (click)="search()" [disabled]="busy || !fromNumber">Search</button>
    </div>
    <p *ngIf="busy">Searching...</p>
    <p *ngIf="error" class="error">{{ error }}</p>
    <div *ngFor="let candidate of candidates" class="candidate">
      <span>{{ StringUtils.getShortAddress(candidate.address) }}<br>
        Type: {{ types[candidate.type] || candidate.type || 'Unknown' }} · Prospect #{{ candidate.prospectId }}<br>
        {{ candidate.exactMatch ? 'Exact address match' : 'Number range overlaps — verify before choosing' }}
      </span>
      <button nbButton type="button" size="small" status="primary" (click)="choose(candidate)" [disabled]="busy">
        {{ candidate.type === 'HOUSE_GF' ? 'Use this HGF' : 'Use and change to HGF' }}
      </button>
    </div>
    <p *ngIf="searched && !hasExactMatch">No exact main house found. You can create {{ StringUtils.getShortAddress(proposedAddress) }}.</p>
    <p>The main house and its link will be saved when you save the prospect.</p>
  </nb-card-body>
  <nb-card-footer>
    <button nbButton type="button" (click)="cancel()">Cancel</button>
    <button nbButton type="button" status="success" class="ml-2" (click)="create()"
            [disabled]="busy || !searched || hasExactMatch">Create main house HGF</button>
  </nb-card-footer>
</nb-card>
